import React from "react";
import Spacer from "web-common-ssr/src/views/components/Spacer/Spacer";
import InflectionProvider from "web-common-ssr/src/views/__core/InflectionProvider/InflectionProvider";
import { useDeviceInflection } from "web-common-ssr/src/views/__core/InflectionProvider/InflectionProvider";
import "./Banner.scss";
import useEnabledFeatureFlags from "../../hooks/useEnabledFeatureFlags";
import constData from "../../const/const.json";
/**
 * Represents a Banner component
 *
 * @method
 * @returns Banner
 */
export const Banner = () => {
  const { breakpoint } = useDeviceInflection();
  const isSmallDevice = breakpoint.isSmallDevice();
  const { featureFlags: { guestBanner } } = constData;
  const { data = {} } = useEnabledFeatureFlags(guestBanner);

  return (
    <>
      <InflectionProvider>
        {Object.keys(data).length > 0 && (
          <header className="header">
            <div className={isSmallDevice ? "banner-small" : "banner-large"}>
              <div className="container">
                <div className="title">{data?.title}</div>
                {!isSmallDevice && <Spacer title="Spacer" value="01" />}
                <div className="subtitle">{data?.message}</div>
              </div>
            </div>
          </header>
        )}
      </InflectionProvider>

    </>
  );
};

export default Banner;
